import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import { IconButton } from '@mui/material';

export type TextAreaPopoutCloseIconProps = {
    onClickHandler: () => void;
};

export const TextAreaPopoutCloseIcon = ({ onClickHandler }: TextAreaPopoutCloseIconProps) => {
    return (
        <IconButton
            onClick={onClickHandler}
            sx={{
                position: 'absolute',
                right: 1,
                top: 1
            }}
            aria-label="collapse-notes">
            <UnfoldLessIcon
                sx={{
                    animation: 'spin 2s linear infinite',
                    '@keyframes spin': {
                        '0%': {
                            transform: 'rotate(45deg);',
                        },
                        '50%': {
                            transform: 'rotate(45deg) scale(1.1, 1.3) ;',
                        },
                        '100%': {
                            transform: 'rotate(45deg) scale(1) ;',
                        },
                    },
                }} />
        </IconButton>
    );
};
